import { httpClient } from '@/services/http/httpClient'

export type UpdateWatchedVideoParams = {
  videoId: number
}

export async function updateWatched(params: UpdateWatchedVideoParams) {
  const { data } = await httpClient.put(`/users/videos/watched`, {
    params: {
      videoId: params.videoId,
    },
  })

  return data
}
